import { Car, CarDocument, CarDocumentType } from '@/types/car.type.ts';

export function getCarDocuments(car?: Car): Record<CarDocumentType, CarDocument[]> {
    const docs: Record<CarDocumentType, CarDocument[]> = {
        [CarDocumentType.AvtocodReport]: [],
        [CarDocumentType.DiagnosticCard]: [],
        [CarDocumentType.Document]: [],
    };

    if (!car) {
        return docs;
    }

    if (car.documents && car.documents.length > 0) {
        car.documents.forEach((doc: CarDocument) => {
            docs[doc.type].push({ ...doc });
        });
    }

    return docs;
}
